module.exports = __webpack_public_path__ + "static/media/Resume_Duha_Hassan_v3_1_default.5148a7c9.pdf";